function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", {
  id: "voteTitle"
}, "vote");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M29.62 41.5c2.44 0 4.417 1.998 4.417 4.462 0 1.595-.83 2.993-2.075 3.782 2.5.956 4.279 3.395 4.279 6.256H23c0-2.86 1.778-5.3 4.279-6.256-1.246-.789-2.075-2.187-2.075-3.782 0-2.464 1.977-4.461 4.416-4.461zm24.831-.053v14.514H40.084V41.447H54.45zm-2.568 2.595h-9.23v9.325h9.23v-9.325zm0-19.86v2.595h-9.23v9.325H54.45v2.594H40.084V24.182h11.799zm-22.263.008c2.44 0 4.417 1.997 4.417 4.461 0 1.595-.83 2.993-2.075 3.782 2.5.956 4.279 3.396 4.279 6.256H23c0-2.86 1.778-5.3 4.279-6.256-1.246-.789-2.075-2.187-2.075-3.782 0-2.464 1.977-4.461 4.416-4.461zM57.111 24L59 25.908l-7.4 7.476-1.854 1.872-.035.036-5.57-5.627 1.889-1.908 3.681 3.718 7.4-7.475z",
  transform: "translate(-609 -650) translate(609 650)"
}))));

var SvgPrimaryButtonUiVoteIcon = function SvgPrimaryButtonUiVoteIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    "aria-labelledby": "voteTitle",
    role: "img",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", {
    id: "voteTitle"
  }, title) : null, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPrimaryButtonUiVoteIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/primary-button-ui-vote-icon.fd540aba.svg";
export { ForwardRef as ReactComponent };